
import React from "react";
import { usePageSEO } from "@/hooks/use-seo";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, Phone, MapPin } from "lucide-react";
import PublicHeader from "@/components/layout/PublicHeader";

const Contact: React.FC = () => {
  usePageSEO("Contact Zoocertica - Wildlife Management Support", "Get in touch with the Zoocertica team for support, demos, or questions about our wildlife facility management platform.", "/contact");

  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />
      <div className="container mx-auto py-8 px-4 max-w-4xl">
        <div className="space-y-8">
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold tracking-tight">Contact Us</h1>
            <p className="text-xl text-muted-foreground">
              We're here to help with your accreditation management needs
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2 max-w-2xl mx-auto">
            <Card>
              <CardHeader className="text-center">
                <Mail className="h-8 w-8 mx-auto mb-2 text-primary" />
                <CardTitle>General Inquiries</CardTitle>
                <CardDescription>
                  Feature requests, platform information, and general questions
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center">
                <a 
                  href="mailto:info@zoocertica.com" 
                  className="text-primary hover:underline font-medium"
                >
                  info@zoocertica.com
                </a>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="text-center">
                <Mail className="h-8 w-8 mx-auto mb-2 text-primary" />
                <CardTitle>Technical Support</CardTitle>
                <CardDescription>
                  Account issues, billing questions, error reporting, and troubleshooting
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center">
                <a 
                  href="mailto:support@zoocertica.com" 
                  className="text-primary hover:underline font-medium"
                >
                  support@zoocertica.com
                </a>
              </CardContent>
            </Card>
          </div>

          <Card className="max-w-2xl mx-auto">
            <CardHeader>
              <CardTitle>Frequently Asked Questions</CardTitle>
              <CardDescription>
                Quick answers to common questions
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <h3 className="font-semibold mb-2">How do I get started with ZooCertica?</h3>
                <p className="text-sm text-muted-foreground">
                  Simply create an account and you'll be guided through the setup process. Our team can help you migrate your existing data.
                </p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Is my data secure?</h3>
                <p className="text-sm text-muted-foreground">
                  Yes, we use enterprise-grade security measures including encryption, secure backups, and role-based access controls.
                </p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Can multiple users access the same organization?</h3>
                <p className="text-sm text-muted-foreground">
                  Absolutely! ZooCertica supports multi-user organizations with different permission levels for admins and members.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Contact;
